import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AutoLogoutService } from '../services/auto-logout.service';

@Injectable()
export class FreezeInterceptor implements HttpInterceptor {
  constructor(private autoLogOutService: AutoLogoutService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.autoLogOutService.freeze.getValue()) {
      return EMPTY;
    }

    return next.handle(req);
  }
}
